export const GET_GAME_DASHBOARD_LOADING = "GET_GAME_DASHBOARD_LOADING"
export const GET_GAME_LIST = "GET_GAME_LIST"
export const GET_GAME_LIST_REQUEST = "GET_GAME_LIST_REQUEST"
export const UPDATE_GAME_LIST_REQUEST = "UPDATE_GAME_LIST_REQUEST"
export const CLEAR_GAME_LIST_REQUEST = "CLEAR_GAME_LIST_REQUEST"
export const GET_GAME_LIST_DROPDOWN = "GET_GAME_LIST_DROPDOWN"
export const GET_GAME_DASHBOARD = "GET_GAME_DASHBOARD"
export const UPDATE_GAME_DASHBOARD_REQUEST = "UPDATE_GAME_DASHBOARD_REQUEST"
export const CLEAR_GAME_DASHBOARD_REQUEST = "CLEAR_GAME_DASHBOARD_REQUEST"
